import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { isInternalUrl } from 'src/app/shared/util/string-util';
import { ToastService } from '../../service/toast.service';

@Component({
  selector: 'app-toast-host',
  templateUrl: './toast-host.component.html',
  styleUrls: ['./toast-host.component.scss']
})
export class ToastHostComponent implements OnInit, OnDestroy {

  private toastSubscription: Subscription;
  isInternalUrl = isInternalUrl;

  constructor(private toastService: ToastService, private messageService: MessageService, private router: Router) { }

  ngOnInit(): void {
    this.toastSubscription = this.toastService.toast$.subscribe(toast => this.messageService.add(toast));
  }

  ngOnDestroy(): void {
    this.toastSubscription?.unsubscribe();
  }

  goTo(url: string): void {
    void this.router.navigate([url]);
  }

}
